var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArchive = function SvgArchive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4 5.6V15c0 .387-.157.737-.41.99s-.603.41-.99.41H3c-.387 0-.737-.157-.99-.41A1.396 1.396 0 0 1 1.6 15V5.6h14.8Z",
    stroke: "#264D6D",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#264D6D",
    x: 5,
    y: 8,
    width: 8,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 .6c.387 0 .737.157.99.41s.41.603.41.99v3.4H.6V2c0-.387.157-.737.41-.99S1.613.6 2 .6h14Z",
    stroke: "#264D6D",
    strokeWidth: 1.2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArchive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/archive.d055fa7c.svg";
export { ForwardRef as ReactComponent };